var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "MyStatus", class: [_vm.status] },
    [
      _c("svg-icon", {
        attrs: {
          "icon-class": _vm.statesPop[_vm.status],
          "class-name": "icon",
        },
      }),
      _c(
        "div",
        { staticClass: "title" },
        [_vm._v(_vm._s(_vm.title)), _vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }